import { MedusaProduct, MedusaProductVariant } from 'lib/home/generated/types/api';

export function selectProductVariants(
  products: MedusaProduct[],
  options?: { collection_title?: string; sku_filter?: string }
): MedusaProductVariant[] {
  const filteredProductsByCollection = options?.collection_title
    ? products.filter(product => product.collection?.title === options.collection_title)
    : products;

  if (!filteredProductsByCollection) return [];
  return filteredProductsByCollection.reduce<MedusaProductVariant[]>((acc, curr) => {
    if (!curr.variants) return acc;
    if (curr.variants?.length >= 1) {
      curr.variants.forEach(variant => {
        // Note: we are filtering variants with titles that don't match the sku_filter
        if (options?.sku_filter) {
          if (variant.sku && variant.sku.toLowerCase().indexOf(options.sku_filter.toLowerCase()) === -1) return;
        }

        acc.push({
          ...variant,
          product: curr
        } as any);
      });
    }
    return acc;
  }, []);
}
